import { render, staticRenderFns } from "./KeyboardEvents.vue?vue&type=template&id=528c5488&scoped=true&"
import script from "./KeyboardEvents.vue?vue&type=script&lang=js&"
export * from "./KeyboardEvents.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardEvents.vue?vue&type=style&index=0&id=528c5488&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528c5488",
  null
  
)

export default component.exports